$(document).ready(function() {
    var productsFav = localStorage.getItem('products_favrc');
    var existingEntries = JSON.parse(productsFav) || [];

    function updateFavoriteIcon() {
        var count = existingEntries.length;
        $('header#header .favorite_icon').html(count).attr('data-number', count);
    }

    function markFavoriteProducts() {
        $('.product, .p-info-wrapper').each(function() {
            var productId = $(this).find('meta[itemprop="sku"], span[data-micro="sku"]').attr('content') || $(this).find('span[data-micro="sku"]').text().trim();
            if (existingEntries.some(entry => entry.id === productId)) {
                $(this).addClass('activeFavorite');
            }
        });

    }
    $(document).ready(function(){
        markFavoriteProducts();
        if($('.type-detail').length){
            var productId = $('#product-detail-form').find('meta[itemprop="sku"]').attr('content');
            if (existingEntries.some(entry => entry.id === productId)) {
                $('.p-info-wrapper').addClass('activeFavorite');
            }
        }
    })
   

    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        markFavoriteProducts()
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        markFavoriteProducts();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        markFavoriteProducts();
    });

    function saveProductData(productElement, isDetailPage) {
        var idProduct, productName, productPrice, productData;

        if (isDetailPage) {
            idProduct = productElement.closest('.p-detail-inner').find('#product-detail-form meta[itemprop="sku"]').attr('content');
            productName = productElement.find('.p-detail-inner-header h1').html().trim();
            productPrice = productElement.find('.p-final-price-wrapper').html();
            productUrl = document.location.pathname;
            productDescription = productElement.find('.p-short-description').text().trim();
            if (productDescription.length > 92) {
                var shortenedDescription = productDescription.substring(0, 92) + '...';
                
            }
            else{
                shortenedDescription = productElement.find('.p-short-description').text().trim();
            }
            if(productElement.find('.p-detail-info .flags').length){
                productFlags = '<div class="flags flags-default">'+productElement.find('.p-detail-info .flags').html()+'</div>'
            }
            else{
                productFlags = ''
            }
            if(productElement.closest('.product-top').find('.p-image-wrapper .p-thumbnails-inner a').hasClass('show360image')){
                firstImage = productElement.closest('.product-top').find('.p-image-wrapper .p-thumbnails-inner a.p-thumbnail').eq(1).find('img').attr('data-src')
                secondImage = productElement.closest('.product-top').find('.p-image-wrapper .p-thumbnails-inner a.p-thumbnail').eq(2).find('img').attr('data-src')
                productImageSection = '<img src="'+firstImage.replace('/related/', '/detail/')+'" data-src="'+secondImage.replace('/related/', '/detail/')+'" alt="'+productElement.find('.p-detail-inner-header h1').text()+'" data-micro-image="'+firstImage.replace('/related/', '/big/')+'">'+productFlags
                
            }
            else{
                firstImage = productElement.closest('.product-top').find('.p-image-wrapper .p-thumbnails-inner a.p-thumbnail').eq(0).find('img').attr('data-src')
                secondImage = productElement.closest('.product-top').find('.p-image-wrapper .p-thumbnails-inner a.p-thumbnail').eq(1).find('img').attr('data-src')
                productImageSection = '<img src="'+firstImage.replace('/related/', '/detail/')+'" data-src="'+secondImage.replace('/related/', '/detail/')+'" alt="'+productElement.find('.p-detail-inner-header h1').text()+'" data-micro-image="'+firstImage.replace('/related/', '/big/')+'">'+productFlags
            }
            

        } else {
            idProduct = productElement.find('span[data-micro="sku"]').text().trim();
            productName = productElement.find('.p-in-in .name').html().trim();
            productPrice = productElement.find('.prices').html().trim();
            productUrl = productElement.find('.p-in-in .name').attr('href');
            productImageSection = productElement.find('.image').html().trim();
            shortenedDescription = productElement.find('.p-desc').html().trim()

        }

        var index = existingEntries.findIndex(entry => entry.id === idProduct);

        if (index === -1) {
            productData = { id: idProduct, name: productName, price: productPrice,  url: productUrl, imagesection: productImageSection, productdesription: shortenedDescription};
            console.log(productData)
            existingEntries.push(productData);
            productElement.addClass('activeFavorite');
        } else {
            existingEntries.splice(index, 1);
            productElement.removeClass('activeFavorite');
        }

        localStorage.setItem('products_favrc', JSON.stringify(existingEntries));
        updateFavoriteIcon();
    }

    $('body').on('click', '.product .btn_toggle, .p-info-wrapper .btn_toggle', function() {
        var productElement = $(this).closest('.product, .p-info-wrapper');
        var isDetailPage = $(this).closest('.p-info-wrapper').length > 0;
        saveProductData(productElement, isDetailPage);
    });

    var favIconHTML = '<a href="' + favorite_url + '" class="favorite"><i class="favorite_icon"></i></a>';
    $('header#header .navigation-buttons, .responsive-tools').prepend(favIconHTML);
    updateFavoriteIcon();
    markFavoriteProducts();

    // Výpis oblíbených na URL /oblibene/
    if (window.location.pathname === '/oblibene/') {
        if(existingEntries){
            $('div[itemprop="about"]').append('<div id="products" class="products products-page products-block" data-testid="productCards"></div>')
            existingEntries.forEach(function(entry) {
                console.log(entry)
                var favoriteProduct = '<div class="product">'
                    favoriteProduct += '<div class="p swap-images">'
                        favoriteProduct +='<a href="'+entry.url+'" class="image">'+entry.imagesection+'</a>'
                        favoriteProduct += '<div class="p-in">'
                            favoriteProduct += '<div class="p-in-in">'
                                favoriteProduct += '<a href="'+entry.url+'" class="name" data-micro="url">'+entry.name+'</a>'
                            favoriteProduct += '</div>'
                            favoriteProduct += '<div class="p-bottom">'
                                favoriteProduct += '<div data-micro="offer">'
                                    favoriteProduct += '<div class="prices">'+entry.price+'</div>'
                                    favoriteProduct += '<div class="p-tools"><a href="'+entry.url+'" class="btn btn-primary">Detail</a></div>'
                                    if(typeof entry.productdesription !== "undefined"){
                                        favoriteProduct += '<p class="p-desc" data-micro="description" data-testid="productCardShortDescr">'+entry.productdesription+'</p>'
                                    }
                                    else{
                                        favoriteProduct += '<p class="p-desc" data-micro="description" data-testid="productCardShortDescr"></p>'
                                    }
                                    
                                favoriteProduct += '</div>'
                            favoriteProduct += '</div>'
                        favoriteProduct += '</div>'
                        favoriteProduct += '<span class="no-display" data-micro="sku">'+entry.id+'</span>'
                        
                    favoriteProduct += '</div>'
                favoriteProduct += '</div>'
                $('#products').append(favoriteProduct)
                // Zde přidejte kód pro vytvoření HTML elementu pro každý oblíbený produkt
                // Například:
                // $('#favoriteProductsContainer').append('<div>' + entry.name + ' - ' + entry.price + '</div>');
            });
            $(document).on('click', '.btn_toggle', function(){
                $(this).closest('.product').remove()
            })
        }
        
    }
});
